import styled from "@emotion/styled";
import { Theme } from "@emotion/react";
import { MDSText } from "@/mds/components/text";
import { Button } from "react-aria-components";

// Define styles as a function that takes theme
const sharedStyles = (theme: Theme) => `
  display: block;

  border-radius: ${theme.borderRadius.medium};
  background: ${theme.colors.background.card.default};
  padding: ${theme.spacing["4"]};
  box-shadow: ${theme.shadows.surface};
  border: 1px solid ${theme.colors.border.default};
  transition: all 0.2s ease;

  &:disabled, &[disabled] {
    opacity: 0.4;
    cursor: not-allowed;
    box-shadow: none;
    border-color: ${theme.colors.border.default};
    background: ${theme.colors.background.card.default};
    transform: none;
    pointer-events: none;
  }
`;

export const StyledCard = styled.div`
  ${({ theme }) => sharedStyles(theme)}
`;

export const StyledButton = styled(Button)`
  ${({ theme }) => sharedStyles(theme)}

  padding: ${({ theme }) => theme.spacing[4]};
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing[2]};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background: ${({ theme }) => theme.colors.background.button.chrome.default};
  box-shadow: unset;
  border: unset;

  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-start;

  & > div {
    width: 100%;
  }
`;

export const StyledButtonContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  gap: ${({ theme }) => theme.spacing[1]};
`;

export const StyledCardHeader = styled.div`
  display: flex;
  align-items: left;
  gap: ${({ theme }) => theme.spacing["3"]};
`;

export const StyledCardIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.icon.secondary};
  & svg {
    font-size: ${({ theme }) => theme.fontSizes["header-s"]};
  }
  margin-left: 2px;
`;

export const StyledCardTitle = styled(MDSText)``;

export const StyledCardRightAddon = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["1"]};
  font-size: ${({ theme }) => theme.fontSizes["paragraph-s"]};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.icon.secondary};
`;

export const StyledCardDescription = styled(MDSText)`
  text-align: left;
  text-wrap: wrap;
  margin-left: ${({ theme }) => theme.spacing[8]};
`;

export const StyledCardContent = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${({ theme }) => theme.fontSizes["text-m"]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.colors.text.secondary};
  text-align: left;
`;
